import React, { FC } from 'react';
import { Box, Flex, DeprecatedIcon, Tooltip, Typography } from '@fullstory/components';
import { ADJUSTED_TIME_RANGE_MESSAGE } from '../../constants';
import { FormattedMessage, useIntl } from 'react-intl';

export const testIds = {
  ADJUSTED_TIME_RANGE_TOOLTIP: 'adjusted-time-range-tooltip',
  RESTRICTED_TIME_RANGE_TOOLTIP: 'restricted-time-range-tooltip',
};

const AdjustedTimeRangeWarning = () => (
  <Flex justifyContent="flex-start">
    <Box marginLeft={8}>
      <Tooltip
        placement="top"
        tooltipContent={ADJUSTED_TIME_RANGE_MESSAGE}
        testId={testIds.ADJUSTED_TIME_RANGE_TOOLTIP}
      >
        <DeprecatedIcon name="error-warning-fill" color="yellow-base" size={16} />
      </Tooltip>
    </Box>
  </Flex>
);

export const TimePeriodLabel: FC<{
  extendedTimeRange: boolean;
  dateRangeModified: boolean;
}> = ({ dateRangeModified, extendedTimeRange }) => {
  const intl = useIntl();
  if (extendedTimeRange) {
    return (
      <>
        <Typography variant="body3">
          <FormattedMessage defaultMessage="Time range" id="74vgSJ" />
        </Typography>
        {dateRangeModified && <AdjustedTimeRangeWarning />}
      </>
    );
  } else {
    return (
      <>
        <Tooltip
          placement="top"
          tooltipContent={intl.formatMessage({
            defaultMessage: 'Perform an Analysis on ranges up to 31 days.',
            id: 'OW149w',
          })}
          testId={testIds.RESTRICTED_TIME_RANGE_TOOLTIP}
        >
          <Typography variant="body3" underline="dashed">
            <FormattedMessage defaultMessage="Time range" id="74vgSJ" />
          </Typography>
        </Tooltip>
        {dateRangeModified && <AdjustedTimeRangeWarning />}
      </>
    );
  }
};
